import { useState } from "react";

const faqs = [
  {
    q: "奶水动漫可以免费在线观看吗？",
    a: "可以。奶水动漫提供热门动画免费在线观看服务，无需注册登录，点开详情页选择对应集数即可播放，覆盖热血、奇幻、科幻、恋爱、悬疑等多类型动画。",
  },
  {
    q: "如何下载高清资源到本地？",
    a: "进入番剧详情页，选择想要保存的集数与清晰度，复制页面提供的下载直链，或使用支持离线下载的工具即可保存到本地，支持 1080P 与 4K 画质。",
  },
  {
    q: "新番的更新频率是怎样的？",
    a: "资源站会持续整理更新，热门新番通常在上线后同步更新集数，完结番剧则一次性收录全集，建议收藏关注你想追的番剧。",
  },
  {
    q: "支持哪些观看设备？",
    a: "网站采用响应式设计，在电脑、平板与手机上均可流畅观看，页面会随屏幕尺寸自适应布局，方便随时随地点开即追更。",
  },
  {
    q: "下载的资源是什么格式？",
    a: "提供的高清资源以主流视频格式为主，兼容常见播放器，下载后可离线观看或转存，满足漫迷存番收藏的需求。",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-background-900/40 py-10 md:py-14">
      <div className="container-site grid gap-10 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-50 md:text-3xl">
            <i className="ri-question-answer-line text-primary-500" />
            常见问题
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-400">
            关于免费观看、高清下载与资源更新，这里汇总了漫迷们最常问的问题。如果仍有疑问，欢迎通过关于我们页面的联系方式向我们反馈。
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {["免费", "高清", "全集", "下载", "更新"].map((t) => (
              <span key={t} className="rounded-full bg-secondary-500/10 px-3 py-1 text-xs text-secondary-300">
                #{t}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="space-y-3">
            {faqs.map((f, idx) => {
              const isOpen = open === idx;
              return (
                <div key={f.q} className="overflow-hidden rounded-lg border border-background-800 bg-background-900">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : idx)}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className="text-sm font-bold text-foreground-100 md:text-base">{f.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform ${
                        isOpen ? "rotate-180 bg-primary-500 text-background-950" : "bg-background-800 text-foreground-300"
                      }`}
                    >
                      <i className="ri-arrow-down-s-line text-lg" />
                    </span>
                  </button>
                  {isOpen && <p className="border-t border-background-800 px-5 py-4 text-sm leading-relaxed text-foreground-400">{f.a}</p>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}